const faqs = [
    { 
        id: 1, 
        heading: 'What are the best trails for beginners?',
        content: 'Explore our recommended beginner-friendly trails, featuring easy terrain and scenic views. Plan your hike and enjoy the beauty of nature at your own pace.',
    },
    {
        id: 2,
        heading: 'What camping gear do you recommend?',
        content: 'Discover our recommended camping gear for first-time campers, including essential equipment like tents, sleeping bags, and cooking utensils. Get prepared for your outdoor adventure with quality gear.',
    },
    { 
        id: 3,
        heading: 'What are some safety tips for hiking in the wilderness?',
        content: 'Learn essential safety tips for hiking in the wilderness, including how to plan your trip, what to pack, and how to stay safe in various outdoor conditions. Be prepared and enjoy a safe hiking experience.',
    },
    {
        id: 4,
        heading: 'What are the Leave No Trace principles?',
        content: 'Learn about the Leave No Trace principles, guidelines for responsible outdoor recreation that minimize human impact on the environment. Understand how to leave wilderness areas pristine for future generations to enjoy.',
    },
    {
        id: 5,
        heading: 'Do you organize group hiking events?',
        content: 'Find out about our upcoming group hiking events, including guided hikes, trail clean-up days, and community outreach initiatives. Join us for a memorable outdoor adventure with like-minded enthusiasts.',
    },
];

export default faqs;